import { RightCircleOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import survayImage from "../assets/images/survayImage.png";
import SurveyLogo from "../assets/images/survey_logo.svg";
import { SurveyMenu } from "../utils/icons";
function Survey() {
  const navigate = useNavigate();

  const items = [
    {
      key: "2",
      label: (
        <a rel="noopener noreferrer" onClick={() => navigate("/survey")}>
          About M3
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a rel="noopener noreferrer" onClick={() => navigate("/Survey-Form")}>
          Fill Form
        </a>
      ),
    },
  ];
  return (
    <div className="lg:flex">
      <div className="lg:w-[50%] relative flex justify-center">
        <div className="flex items-center justify-between absolute top-5 p-3 bg-[#FFFFFF33] rounded-3xl mx-5 w-[95%]">
          <img src={SurveyLogo} alt="SurveyLogo" />
          <Dropdown
            menu={{
              items,
            }}
            placement="bottomRight"
          >
            <button>
              <SurveyMenu />
            </button>
            {/* <a onClick={(e) => e.preventDefault()}>
            </a> */}
          </Dropdown>
        </div>
        <div>
          <img
            src={survayImage}
            alt="Survay"
            className="w-full sm:h-auto lg:h-[100vh] "
          />
        </div>
      </div>
      <div className="lg:w-[50%]">
        <div className="relative  p-3 pb-10 bg-[linear-gradient(93.78deg,_#F36132_0.23%,_#FFE39C_116.26%)]">
          <h1 className="font-semibold text-pureWhite text-3xl">
            Do you have the spark to change the world?
          </h1>
          <p className="text-pureWhite mt-2">
            Mawhiba MetaMinds, the world's leading gifted-mind platform, is your
            chance to shine. Take a moment to fill out the M3 form, and let's
            make a real impact on humanity.
          </p>
          <button
            onClick={() => navigate("/survey-form")}
            className="bg-[#F36231] p-3 rounded-3xl m-2 flex items-center gap-3 text-pureWhite absolute bottom-[-30]"
          >
            Fill out the form <RightCircleOutlined className="text-pureWhite" />
          </button>
        </div>
        <div className="p-5 space-y-5 mt-5">
          <div>
            <h1 className="bg-signupTextBg inline-block text-transparent bg-clip-text font-bold text-lg">
              Who we are ?{" "}
            </h1>
            <p>
              Mawhiba MetaMinds embodies a vision of empowerment, excellence,
              and growth, where gifted individuals are equipped with the tools,
              support, and inspiration to unlock their full potential and make a
              meaningful difference in the world.
            </p>
          </div>
          <div>
            <h1 className="bg-signupTextBg inline-block text-transparent bg-clip-text font-bold text-lg">
              Ready to Level Up? Let's get in touch!{" "}
            </h1>
            <p>
              Are you interested in joining M3 and embracing the challenges of
              improving your skills? We'd love to hear more about you!
            </p>
          </div>
        </div>
        {/* <div className="flex justify-between items-center absolute bottom-0 bg-[linear-gradient(93.78deg,_#FFFFFF_0.23%,_#EDEDED_116.26%)] w-full">
          <button
            onClick={() => navigate("/")}
            className="bg-[#F36231] py-1 px-3 rounded-3xl m-2 flex items-center gap-3 text-pureWhite text-sm"
          >
            m3.mawhiba.org <RightCircleOutlined className="text-pureWhite" />
          </button>
          <h1 className="bg-signupTextBg inline-block text-transparent bg-clip-text font-bold">
            Mawhiba metaminds 2024©
          </h1>
        </div> */}
      </div>
    </div>
  );
}

export default Survey;
